import http from '../../core/services/http';

export const loadZipcodeDetails = zipCode =>
  zipCode ? http.get(`marketconfig/setup/${zipCode}`).then(response => response.data) : undefined;

export const loadZipcodesAvailability = () =>
  http.get('marketconfig/zip-map-availability').then(response => response.data);
